import EventActionProto from '../../event-action-proto';
import SessionRemindersCollection from "../session-reminders-collection";

module.exports = class SessionRemindersReset extends EventActionProto {

    constructor(uid, data, sid, companyId) {
        super(uid, data, companyId);
    }

    process() {

        // never initialized
        if (!gd.session.reminders) {
            gd.session.reminders = new SessionRemindersCollection(this.data);
        } else {
            gd.session.reminders.reset(this.data, true);
        }

        super.process();
    }
};